<app-floorplan-product-menu
  [title]="tooltipTextFlameDetectors"
  [hasConfigurations]="flameDetectors.length > 0"
  [visible]="floorplan.floorplanState.flameDetectorsVisible"
  [locked]="floorplan.floorplanState.flameDetectorsLocked"
  [itemTextVisible]="floorplan.floorplanState.flameDetectorsItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.flameDetectorsVisible = $event"
  (lockUpdate)="floorplan.floorplanState.flameDetectorsLocked = $event"
  (itemTextVisibilityUpdate)="updateFlameDetectorsItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="flame-detector"
>
  <button
    additionalButton
    odxButton
    variant="secondary"
    (click)="toggleCoverageAreaVisibility()"
    [odxTooltip]="floorplan.floorplanState.coverageAreasVisible ? tooltipTextHideCoverageArea : tooltipTextShowCoverageArea"
    [odxTooltipOptions]="{ position: 'bottom' }"
  >
    <img
      alt="Überwachungsbereich ein-/ausblenden"
      class="odx-icon"
      [src]="
        floorplan.floorplanState.monitoringAreasVisible
          ? '../../../../assets/floorplan-menu-icons/ueberwachungsbereich_on_nicht_odx.svg'
          : '../../../../assets/floorplan-menu-icons/ueberwachungsbereich_off.svg'
      "
    />
  </button>

  @for (flameDetectorSubtitle of flameDetectorSubtitles | keyvalue; track flameDetectorSubtitle) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="flameDetectorSubtitle.key"
        [numberOfFloorplanItems]="floorplan.countPlacedFlameDetectors(flameDetectorSubtitle.key)"
        [attachments]="flameDetectorSubtitle.key.attachments"
        [substanceSubtitle]="(flameDetectorSubtitle.value | async) ?? ''"
        (add)="addFlameDetector(flameDetectorSubtitle.key)"
        (delete)="deleteFlameDetector(flameDetectorSubtitle.key)"
        (dragStart)="drag(flameDetectorSubtitle.key)"
        editPath="flame-detector"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
